import React, { useEffect } from 'react';

export default function Toast({ message, onClose, duration = 2500 }) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  if (!message) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      background: 'var(--gold)',
      color: 'var(--ink)',
      padding: '14px 24px',
      borderRadius: '0',
      fontFamily: 'var(--font-mono)',
      fontSize: '0.75rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      zIndex: 400,
      boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
      animation: 'slideUp 0.3s ease',
    }}>
      {message}
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
